<template>
    <MainLayout class="c-jiwei-project-detail" :showRight="false">
        <BgWrap slot="left" class="c-jiwei-project-detail__left">
            <Left @treeChildreClick="handleLeftClick"></Left>
        </BgWrap>
        <div slot="main" class="c-jiwei-project-detail__main">
            <Middle :title="title" :projectId="id"></Middle>
        </div>
    </MainLayout>
</template>

<script>
import MainLayout from '../../layout/MainLayout';
import BgWrap from '../../layout/components/BgWrap.vue';
import Middle from './Middle/Middle.vue';
import Left from '../Left/Left.vue';
// import * as Api from '../Api';

export default {
    components: {
        MainLayout,
        BgWrap,
        Middle,
        Left,
    },
    data() {
        return {
            id: '',
            title: '',
        };
    },
    methods: {
        handleLeftClick(data) {
            // this.$router.push({ path: '/jiwei/land/detail', query: { id: data.id, name: data.name } });
            this.$route.query.id = data.id;

            this.$route.query.name = data.name;

            this.getRouteQuery();
        },
        // 获取路由参数
        getRouteQuery() {
            const query = this.$route.query;
            if (query) {
                this.id = query.id;
                this.title = query.name;
            }
        },
    },
    created() {
        this.getRouteQuery();
    },
    mounted() {},
};
</script>

<style lang="scss" scoped>
@import '~@Theme/config.scss';
@import '~@Theme/mixins/index.scss';
$bg-1: #071150;
$bg-2: #03053d;
$bg-3: #c4c4c4;

@include b(jiwei-project-detail, c) {
    color: #fff;
    background: $bg-2;
    padding: 18px 8px 8px 8px;

    @include e(content) {
        padding: 10px;
        height: calc(100% - 20px);
    }

    @include e(left) {
        height: 100%;
        background-color: $bg-1;
    }

    @include e(main) {
        height: 100%;
        margin: 0px 10px;
    }

    @include e(right) {
        height: 100%;
        background-color: $bg-3;
    }
}
</style>
